/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React, { useContext } from 'react';
import { Box, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { ReactComponent as Plus } from 'assets/images/plus.svg';
import { FormDataContext } from 'app/providers/formValues/lib/FormDataContext';
import { AdditionalSmallItemIcon } from '../Accordion';

interface EditableCoverageProps {
	coverageName: string;
	isDisabled?: boolean;
}

const EditableCoverage = ({ coverageName, isDisabled = false }: EditableCoverageProps) => {
	const { initialPayload, setProtections, setInitialPayloadData } = useContext(FormDataContext);

	// Get the current value from initialPayload instead of protections
	const currentItem = initialPayload?.coverage.parameters.find((item) => item.name === coverageName);
	const isChecked = currentItem?.value === 'Y';

	const handleToggle = () => {
		if (isDisabled) return;

		const newValue = isChecked ? 'N' : 'Y';

		setProtections((prevState) => {
			return { ...prevState, [coverageName]: newValue };
		});

		setInitialPayloadData((prevState) => {
			const newParametersData = prevState.coverage.parameters.map((item) => {
				if (item.name === coverageName) {
					return { ...item, value: newValue };
				}
				return item;
			});
			return {
				...prevState,
				coverage: {
					parameters: newParametersData,
				},
			};
		});
	};

	return (
		<Box
			display="flex"
			alignItems="center"
			onClick={handleToggle}
			sx={{ cursor: isDisabled ? 'default' : 'pointer' }}
		>
			{isChecked ? (
				<>
					<AdditionalSmallItemIcon sx={{ backgroundColor: 'primary.light' }}>
						<CheckIcon />
					</AdditionalSmallItemIcon>
					<Typography fontWeight={800} textAlign="right" sx={{ ml: 1 }}>
						Added
					</Typography>
				</>
			) : (
				<>
					<AdditionalSmallItemIcon sx={{ backgroundColor: 'primary.light' }}>
						<Plus />
					</AdditionalSmallItemIcon>
					<Typography fontWeight={800} textAlign="right" sx={{ ml: 1 }}>
						Add
					</Typography>
				</>
			)}
		</Box>
	);
};

export default EditableCoverage;
